import { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Search, Archive, ArchiveRestore, Edit2, ClipboardCheck } from "lucide-react";

export default function AdminYouthList() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [statusFilter, setStatusFilter] = useState("active");
  const [churchFilter, setChurchFilter] = useState("");
  const nav = useNavigate();

  const load = () => {
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    if (churchFilter) p.set("church", churchFilter);
    p.set("status", statusFilter);
    api.get(`/youth?${p.toString()}`).then((r) => setList(r.data));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q, statusFilter, churchFilter]);

  const churches = useMemo(() => [...new Set(list.map((y) => y.church).filter(Boolean))], [list]);

  const archive = async (y) => {
    if (!confirm(`Arquivar ${y.full_name}? O histórico será preservado.`)) return;
    await api.post(`/youth/${y.id}/archive`);
    toast.success("Arquivado");
    load();
  };
  const restore = async (y) => {
    await api.post(`/youth/${y.id}/restore`);
    toast.success("Restaurado");
    load();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="label">Gestão de Jovens</div>
          <h1 className="font-display text-3xl sm:text-4xl font-black mt-2">Fichas</h1>
          <p className="text-sm text-slate-400 mt-1">{list.length} jovem(ns) {statusFilter === "archived" ? "arquivado(s)" : statusFilter === "all" ? "no total" : "ativo(s)"}</p>
        </div>
        <button data-testid="youth-new-btn" onClick={() => nav("/admin/jovens/novo")} className="btn-primary"><Plus size={16}/> Novo cadastro</button>
      </div>

      <div className="flex gap-3 flex-wrap">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
          <input data-testid="youth-search" placeholder="Nome, WhatsApp, telefone..." value={q} onChange={(e)=>setQ(e.target.value)} className="ci-input pl-10" />
        </div>
        <select value={statusFilter} onChange={(e)=>setStatusFilter(e.target.value)} className="ci-input min-w-[140px] flex-none">
          <option value="active">Ativos</option>
          <option value="archived">Arquivados</option>
          <option value="all">Todos</option>
        </select>
        {churches.length > 0 && (
          <select value={churchFilter} onChange={(e)=>setChurchFilter(e.target.value)} className="ci-input min-w-[160px] flex-none">
            <option value="">Todas as igrejas</option>
            {churches.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        )}
      </div>

      <div className="grid gap-3">
        {list.map((y) => (
          <div key={y.id} data-testid={`youth-row-${y.id}`} className="ci-card p-4 sm:p-5 flex items-center justify-between flex-wrap gap-3">
            <Link to={`/admin/jovens/${y.id}`} className="flex-1 min-w-0 flex items-center gap-4">
              <div className="w-11 h-11 rounded-full bg-blue-500/20 border border-blue-500/40 flex items-center justify-center font-display font-bold text-blue-300 shrink-0">
                {y.full_name?.[0]?.toUpperCase() || "?"}
              </div>
              <div className="min-w-0">
                <div className="font-display font-bold truncate">{y.full_name}</div>
                <div className="text-xs text-slate-400 mt-0.5 flex items-center gap-2 flex-wrap">
                  {y.age != null && <span>{y.age} anos</span>}
                  {y.church && <span>· {y.church}</span>}
                  <span>· {y.attendance_count} presença(s)</span>
                  {!y.is_complete && <span className="text-amber-400">· Cadastro incompleto</span>}
                </div>
              </div>
            </Link>
            <div className="flex gap-2">
              <Link to={`/admin/jovens/${y.id}`} className="btn-ghost text-xs py-2 px-3"><Edit2 size={14}/></Link>
              <button onClick={() => nav(`/admin/presenca?youth=${y.id}`)} className="btn-ghost text-xs py-2 px-3" title="Registrar presença"><ClipboardCheck size={14}/></button>
              {y.status === "archived" ? (
                <button onClick={() => restore(y)} className="btn-ghost text-xs py-2 px-3"><ArchiveRestore size={14}/></button>
              ) : (
                <button onClick={() => archive(y)} className="btn-ghost text-xs py-2 px-3 border-amber-500/30 text-amber-300"><Archive size={14}/></button>
              )}
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="ci-card p-10 text-center text-slate-400">Nenhum jovem encontrado.</div>}
      </div>
    </div>
  );
}
